<template>
    <Dialog>
        <template v-slot:title>
            {{ $t('message.assign_chat_bot_to_user', {CHAT_BOT: chatBot.displayName}) }}
        </template>

        <template v-slot:body>
            <table width=100% height=100% cellpadding=0 cellspacing=0>
                <tr>
                    <td colspan=2>
                        <div style="padding: 10px;">
                            <el-form @submit.native.prevent="findUser()">
                                <el-radio-group style="padding-left:10px" v-model="listType" fill="#5171cb">
                                    <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                    <el-radio-button :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                                </el-radio-group>
                                <el-input v-if="listType === 1" :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" clearable class="object-search-select">
                                    <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                        <el-option :label="$t('message.item_userId')" value="userId"></el-option>
                                        <el-option :label="$t('message.item_userDisplayName')" value="userName"></el-option>
                                    </el-select>
                                    <el-button slot="append" style="width: 100px;vertical-align:middle" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                </el-input>
                            </el-form>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="dialog-td">
                        <div class="inner-panel-header">
                            <div class="inner-panel-title">
                                <div class="inner-panel-title-left" v-t="'message.title_select_user'">
                                </div>
                                <div v-if="listType === 1" class="inner-panel-title-right">
                                    <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                </div>
                            </div>
                        </div>
                        <div v-if="listType === 0" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                            <DialogTree
                                class="dialog-tree"
                                v-bind:initialData="[rootNode]"
                                @on-selectnode="handleOnSelectNode"
                                selectionType=1
                                ref="dialogTree"
                            />
                        </div>
                        <div v-else class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                            <div class="foundObject-record" v-for="object in foundUserList" @click="addTagWithConditionCheck(object)">
                                <div class="foundObject">
                                    <span style="padding-left:10px;vertical-align:middle">{{ object.displayName }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="dialog-td">
                        <div class="inner-panel-header">
                            <div class="inner-panel-title">
                                <div class="inner-panel-title-left" v-t="'message.title_editing_user'">
                                </div>
                                <div class="inner-panel-title-right">
                                    <button class="transparent" @click="removeAllTag()" type="button"><span class="normal-command-text" v-t="'message.action_delete_all'"></span></button>
                                </div>
                            </div>
                        </div>
                        <div id="selected-user" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                            <div class="selected-item-field">
                                <div class="default-message" v-if="Object.keys(editTagList).length === 0" v-html="$t('message.hint_add_selected_user_from_left_pane')"></div>
                                <span v-for="tag in editTagList" v-bind:key="tag.id">
                                    <div class="userTag">
                                        <span class="userTag-name">{{ tag.displayName }}</span>
                                        <span class="closeTag" @click="removeTag(tag)">×</span>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </template>

        <template v-slot:button>
            <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
            <el-button class="dialog-ok-button" :disabled="disableSave" @click="saveUpdatedInfo()" v-t="'message.button_save'"></el-button>
        </template>
    </Dialog>
</template>

<script>
import Vue from 'vue'
import server from "@/components/ServerApi";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import Dialog from "@/components/pc/common/Dialog";
import DialogTree from "@/components/DialogTree.vue"
import commonutil from "../../../commonutil";

const STATUS_SUCCESS = 0;
const STATUS_ALREADY_EXIST = -1;

export default {
    components: {Dialog, DialogTree},

    props:['chatBot','assignedUserList','tenantId'],

    data() {
        return {
            rootNode: {
                tenantId: this.tenantId,
                id: 1,
                label: "ROOT-NODE",
                type: 0,
                isLeaf: false
            },
            scrollOnAction: false,
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            foundUserList: [],
            assignedUser: [],
            listType: 0,
            condition: "userId",
            searchString: null,
            disableSave: true,
            speechToText: false,
            storageType: false,
        };
    },

    created: function () {
        this.disableSave = true;
        this.assignedUser=this.assignedUserList;
        for (let user of this.assignedUser) {
            this.$set(this.editTagList, user.id, user)
            this.$set(this.orgTagList, user.id, user)
        }
    },

    updated: function () {
        if (this.scrollOnAction) {
            let obj = document.getElementById("selected-user");
            obj.scrollTop = obj.scrollHeight;
            this.scrollOnAction = false;
        }
    },

    methods: {
        findUser() {
            let param = {tenantId: this.tenantId}
            if (this.condition === "userId") {
                param.name = this.searchString;
            } else if (this.condition === "userName") {
                param.displayName = this.searchString;
            }

            let self = this;
            server.post("/finduser", param)
                .then((res) => {
                    if (res.data.status === constants.STATUS_SUCCESS) {
                        if (res.data.userInfo.length === 0) {
                            self.foundUserList = [];
                            commonUtil.notifyMessage(self, "Info", commonUtil.getMessageText(self.$i18n, "info_user_not_found").replace('{object}', commonUtil.getMessageText(self.$i18n, "item_user")));
                            return;
                        }
                    } else {
                        self.foundUserList = [];
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "findUser").replace("{code}", res.data.status));
                        return;
                    }
                    self.foundUserList = [];
                    for (let objectInfo of res.data.userInfo) {
                        if (objectInfo.id === 1000) {
                            // admin
                            continue;
                        }

                        let object = {
                            id: objectInfo.id,
                            name: objectInfo.name,
                            type: constants.OBJECT_USER,
                            displayName: objectInfo.displayName,
                            optionFlag: objectInfo.optionFlag,
                        }
                        self.foundUserList.push(object);
                    }
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "findUser", error);
                    self.foundUserList = [];
                });
        },

        selectTagAll() {
            if (this.countObj(this.addTagList) >= 100) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_add_all_object").replace("{object}", commonUtil.getMessageText(this.$i18n, "item_user")));
                return;
            }

            let addUserCount = 0;
            for (let userNode of this.foundUserList) {
                if (addUserCount >= 100) {
                    break;
                }
                if (this.assignedUser.find(user => user.id === userNode.id)) {
                    continue;
                }
                if (this.checkConditionToAdd(userNode) === STATUS_SUCCESS) {
                    this.addTag(userNode)
                    addUserCount++;
                }
            }
            if (addUserCount !== this.foundUserList.length) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_add_all_object").replace("{object}", commonUtil.getMessageText(this.$i18n, "item_user")));
            }
        },

        addTagWithConditionCheck(tagInfo) {
            switch (this.checkConditionToAdd(tagInfo)) {
                case STATUS_SUCCESS:
                    this.addTag(tagInfo);
                    break;
                case STATUS_ALREADY_EXIST:
                    commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(this.$i18n, "info_user_already_added"));
                    break;
            }
        },

        addTag(tagInfo) {
            this.scrollOnAction = true;
            Vue.set(this.editTagList, tagInfo.id, tagInfo);
            Vue.delete(this.removeTagList, tagInfo.id);
            if (!(tagInfo.id in this.orgTagList)) {
                Vue.set(this.addTagList, tagInfo.id, tagInfo);
            }
            this.disableSave = false;
            return true;
        },

        checkConditionToAdd(tagInfo) {
            if (tagInfo.id in this.editTagList) {
                return STATUS_ALREADY_EXIST;
            }
            return STATUS_SUCCESS;
        },

        handleOnSelectNode(data, node) {
            if (data.type === constants.OBJECT_USER) {
                if ((data.id in this.editTagList)) {
                    commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(this.$i18n, "info_user_already_added"));
                    return;
                }
            } else {
                return;
            }

            let self = this;
            server.post('/getinfo', {tenantId: this.tenantId, id: data.id})
                .then((res) => {
                    if (res.data.status >= 0) {
                        let tagInfo = {
                            id: data.id,
                            name: res.data.name,
                            type: constants.OBJECT_USER,
                            displayName: res.data.displayName,
                        };
                        this.addTagWithConditionCheck(tagInfo);
                    } else {
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "handleOnSelectNode").replace("{code}", res.data.status));
                    }
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "handleOnSelectNode", error);
                });
        },

        removeTag: function (tag) {
            if ((tag.id in this.orgTagList)) {
                Vue.set(this.removeTagList, tag.id, tag);
            }
            Vue.delete(this.addTagList, tag.id);
            Vue.delete(this.editTagList, tag.id)
            this.disableSave = false;
        },

        removeAllTag: function () {
            if (this.countObj(this.removeTagList) >= 100){
                commonUtil.notifyMessage(this, 'Warning', commonUtil.getMessageText(this.$i18n, "error_buddy_bot_api_delete_user_exceed"));
                return;
            }

            let removeCount = 0;
            for (const [key, tag] of Object.entries(this.editTagList)) {
                if (key in this.orgTagList) {
                    this.removeTag(tag)
                    removeCount++;
                }
                if (removeCount >= 100) {
                    commonUtil.notifyMessage(this, 'Warning', commonUtil.getMessageText(this.$i18n, "error_buddy_bot_api_delete_user_exceed"));
                    break;
                }
            }
            this.disableSave = false;
        },

        saveUpdatedInfo() {
            if (this.countObj(this.addTagList) > 100){
                commonUtil.notifyMessage(this, 'Warning', commonUtil.getMessageText(this.$i18n, "error_too_many_tags"));
                return;
            }

            this.$emit('save', {editTagList: this.editTagList, removeTagList: this.removeTagList, addTagList: this.addTagList});
        },

        countObj(obj){
            let count = 0;
            for (let key in obj){
                if (obj.hasOwnProperty(key) && typeof obj[key] === 'object' && obj[key] !== null){
                   count++;
                }
            }

            return count;
        }
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select-dropdown__item {
    font-size: 12px;
}

.el-select-dropdown__item selected {
    color: #5171cb;
}
.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}

</style>

